/**

Coded by www.techhighway.ca

*/

// react-router-dom components
import { Link } from "react-router-dom";

// @mui material components
import Icon from "@mui/material/Icon";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";

// Material Dashboard 2 React example components
import DashboardLayout from "components/LayoutContainers/DashboardLayout";

import DataTable from "components/Tables/DataTable";

// Data
import callsData from "layouts/manage-calls/data";

function Calls() {
  const {
    columns,
    rows,
    totalData,
    page,
    pageSize,
    getData,
    sortColumn,
    sortColumnValue,
    searchValue,
    isData
  } = callsData();

  return (
    <DashboardLayout breadcrumbsTitle="Call Logs">
      <MDBox>
        <DataTable
          entriesPerPage={{
            defaultValue: pageSize,
          }}
          canSearch
          showTotalEntries
          table={{ columns, rows }}
          isSorted
          totalData={totalData}
          initialPageIndex={page - 1}
          getData={getData}
          pageCount={Math.ceil(totalData / pageSize)}
          sortCol={sortColumn}
          sortColValue={sortColumnValue}
          searchVal={searchValue}
          noEndBorder={false}
          isData={isData}
        />
      </MDBox>

      {/* Action buttons for listing pages should go inside this MDBox */}
      <MDBox position="absolute" right="10px" mt={-4.5}>
        <MDButton
          sx={{ marginLeft: "0.75rem" }}
          component={Link}
          color="secondary"
          coloredShadow="secondary"
          variant="gradient"
          onClick={() => getData(page, pageSize, sortColumn, sortColumnValue, searchValue)}
          title="Refresh"
          iconOnly
          circular
        >
          <Icon fontSize="medium" sx={{ fontWeight: "bold", fontSize: "16px" }}>
            refresh
          </Icon>
        </MDButton>
      </MDBox>
    </DashboardLayout>
  );
}

export default Calls;
